// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"StateFooter_footerWrapper__y7uwq","hr":"StateFooter_hr__kaPeh","footerHeading":"StateFooter_footerHeading__2d302"};